<template>
    <div class="container">
  
      <div class="agendamiento_fila row" v-if="item">
        <div class="col-md-4">
          <strong class="cap">{{ textoSolicitado }}</strong><br><small>{{ textoSolicitadoDocumento }}</small>
        </div>
          <div class="col-md-4">
            <!-- div class="d-flex w-100 justify-content-between">
              <strong class="cap mb-1">{{textoCursoAnterior}}</strong>

              <b-link :href="`${urlApi}pdf/cambio-nivel?id=${item.id}`" target="_blank">
                <b-icon variant="info" icon="file-text" ></b-icon>
              </b-link> 
            </div-->
            
            <b-link :href="`${urlApi}pdf/cambio-nivel?id=${item.id}`" target="_blank">
              <b-icon variant="info" icon="file-text" ></b-icon>
            </b-link> &nbsp;
            <strong class="cap mb-1">{{textoCursoAnterior}}</strong>

            <br>
            <span>{{textoFechaFinalizarCurso}}</span>
          </div>
          <div class="col-md-4">
            <strong class="cap">{{textoCursoNuevo}}</strong><br>
            <span>{{textoSede}} - {{textoFechaEntregaLibro}}</span><br>
          </div>
      </div>
      
  
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import Vue from 'vue';
  
    export default {
      name: 'DetalleEntregaLibroItem',
      components: {
      },
      props:{
        item: Object,
        estudiante: Object
      },
      data () {
        return {
          cambiando_tema : false,
          urlApi:'',
        }
      },
      
      mounted () {
        var url = Vue.http.options.root;
        // var str = url.split("api")
        this.urlApi = url;
      },
      methods:{
        ...mapActions({

        }),
        ...mapMutations({
  
        }),
        recargar(){
          
        },
  
      },
      computed: {
        ...mapState({

        }),
        ...mapGetters({
          permiso: 'auth/permiso', 
          getSede: 'sedes/getSede',
        }),
        textoSede(){
          if(this.item && this.item.sede){
            let texto = this.item.sede ? this.item.sede.nombre : "";
            return texto
          }
          return ''
        },
        textoCursoAnterior(){
          if(this.item.cursoAnterior && this.item.cursoAnterior.nombre){
            let texto = this.item.cursoAnterior.nivel.codigo + ": " +this.item.cursoAnterior.nombre
            return texto
          }
          return ''
        },
        textoCursoNuevo(){
          if(this.item && this.item.cursoNuevo && this.item.cursoNuevo.nombre){
            let texto = this.item.cursoNuevo.nivel.codigo + ": " +this.item.cursoNuevo.nombre
            return texto
          } else if(this.item && this.item.nivelSiguiente) {
            let texto = this.item.nivelSiguiente.codigo + ": ";
            return texto;
          }
          return ''
        },
        textoFinalizado(){
          if(this.item){
            if (this.item.finalizado == 1 && this.item.pasa_nivel) {
              return "SI";
            }else {
              return this.item.pasa_nivel ? "PENDIENTE" : "PERDIDA DE NIVEL"
            }
            return texto
          }
          return ''
        },
        textoSolicitado(){
          if(this.item && this.item.administrador){
            let texto = this.item.administrador.primer_nombre+" "+this.item.administrador.primer_apellido;
            return texto
          }
          return ''
        },
        textoSolicitadoDocumento(){
          if(this.item && this.item.administrador){
            let texto = this.item.administrador.numero_documento;
            return texto
          }
          return ''
        },
        textoRespondido(){
          if(this.item && this.item.administrador && this.item.curso_nuevo_id){
            let texto = this.item.administrador.primer_nombre+" "+this.item.administrador.primer_apellido;
            return texto
          }
          return ''
        },
        textoFechaFinalizarCurso(){
          if(this.item && this.item.fecha_finalizar_curso){
            return this.$moment(this.item.fecha_finalizar_curso).format('DD/MM/YYYY h:mm:ss a');
            // let fecha_finalizar_curso = new Date(this.item.fecha_finalizar_curso).toLocaleString()
            // return fecha_finalizar_curso
          }
          return ''
        },
        textoFechaAvanceNivel(){
          if(this.item && this.item.fecha_avance_nivel){
            return this.$moment(this.item.fecha_avance_nivel).format('DD/MM/YYYY h:mm:ss a');
            // let fecha_avance_nivel = new Date(this.item.fecha_avance_nivel).toLocaleString()
            // return fecha_avance_nivel
          }
          return ''
        },
        textoFechaEntregaLibro(){
          if(this.item && this.item.fecha_entrega_libro){
            return this.$moment(this.item.fecha_entrega_libro).format('DD/MM/YYYY h:mm:ss a');
            // let fecha_entrega_libro = new Date(this.item.fecha_entrega_libro).toLocaleString()
            // return fecha_entrega_libro
          } else if(this.item && this.item.created_at){
            return this.$moment(this.item.created_at).format('DD/MM/YYYY h:mm:ss a');
            // let fecha_entrega_libro = new Date(this.item.created_at).toLocaleString()
            // return fecha_entrega_libro
          }
          return ''
        },
        
      }
    }
  </script>
  
  <style scope>
  .agendamiento_fila {
      border-top: 1px solid #bbb;
      font-size:14px;
      line-height: 14px;
      padding-top: 10px !important;
  }
  .agendamiento_fila  strong{}
  .agendamiento_fila  span{
    font-size: 10px;
    line-height: 10px;
    color:#888;
    font-style: oblique;
  }
  .agendamiento_fila  p{
        margin-bottom: 5px !important;
  }
  .agendamiento_fila  button{
        margin: 5px !important;
  }
  .cambiar-tema{
    padding: 10px;
      border: 1px solid grey;
  }
  .cap{
  text-transform: capitalize;  
  }
  </style>